import { IDateRange } from './machine.model';

export interface IChartFilter {
  machineId: number;
  dateRange: IDateRange;
  graphPeriodType: GraphPeriodType;
  zoneId?: string;
}

export enum GraphPeriodType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export interface IChartFromApi {
  x: string;
  y: number;
}
